
<template>
  <el-card shadow="never" class="box-card">
    <div slot="header" class="clearfix">
      <span>{{name}}</span>
    </div>
    <div class="text item paramContainer">
      <el-row :gutter="10">
        <el-col class="paramNameCol" :span="8">
            Minimum
        </el-col>
        <el-col :span="16">
            <el-input-number :step="2" size="mini" v-model="model.params.min_time"></el-input-number>    
        </el-col>
      </el-row>  
      <el-row :gutter="10">
        <el-col class="paramNameCol" :span="8">
            Maximum
        </el-col>
        <el-col :span="16">
            <el-input-number :step="2" size="mini" v-model="model.params.max_time"></el-input-number>
        </el-col>
      </el-row>    
      <div class="tip">
          {{desc}}
      </div>
    </div>
  </el-card>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
export default {
  name: 'Wait',
  data () {
    return {
      name: 'Wait',
      desc: 'You can wait between min and max time',
    }
  }, 
  props: {
      model: {
          type: Object,
          default: () => {}
      },
  },
  methods: {
   
  },
  computed: {
    ...mapState('bot', {
      bot: 'bot',
      project: 'project',
      error: 'error',
      loading: 'loading',
    }),
  },
}
</script>

<style lang="scss" scoped>

</style>
